<template>
    <div>
        <v-simple-table class="table-layout pa-5">
            <template v-slot:default>
                <thead>
                <tr>
                    <th>Sale phụ trách</th>
                    <th>Khách hàng</th>
                    <th>Số liên hệ</th>
                    <th>Thời gian hẹn</th>
                    <th>Tên con</th>
                    <th>Độ tuổi của con</th>
                    <th class="customer-course-column">Khóa học đăng ký</th>
                    <th>Ghi chú</th>
                    <th v-if="showAction">Thao tác</th>
                </tr>
                </thead>
                <template v-if="appointments.length">
                    <tbody v-for="( appointment ) in appointments" :key="appointment.id">
                        <tr>
                            <td :rowspan="appointment.rowspan">{{ _.get(appointment, 'user.fullName') }}</td>
                            <td :rowspan="appointment.rowspan">{{ _.get(appointment, 'customer.fullName') }}</td>
                            <td :rowspan="appointment.rowspan">
                                {{ _.get(appointment, 'mobile') }}
                                <v-tooltip v-if="appointment.customer.contact && checkContactSources(appointment.customer.contact.contactSources)" bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                        size="16"
                                        width="20"
                                        height="20"
                                        class="mr-1"
                                        icon
                                        small
                                        color="info"
                                        v-on="on"
                                        >
                                        <v-icon size="16">mdi-facebook-messenger</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Nhắn tin</span>
                                </v-tooltip>
                                <v-tooltip bottom v-if="appointment.customer.contact && appointment.customer.contact.contactType == 'main'">
                                    <template v-slot:activator="{ on }">
                                    <v-btn
                                        size="16"
                                        width="20"
                                        height="20"
                                        class="mr-1"
                                        icon
                                        small
                                        color="success"
                                        v-on="on"
                                    >
                                        <v-icon size="16">mdi-account-multiple</v-icon>
                                    </v-btn>
                                    </template>
                                    <span>Contact chính</span>
                                </v-tooltip>
                                <v-tooltip bottom v-else-if="appointment.customer.contact && appointment.customer.contact.contactType == 'sub'">
                                    <template v-slot:activator="{ on }">
                                    <v-btn
                                        size="16"
                                        width="20"
                                        height="20"
                                        class="mr-1"
                                        icon
                                        small
                                        color="default"
                                        v-on="on"
                                    >
                                        <v-icon size="16">mdi-account-multiple</v-icon>
                                    </v-btn>
                                    </template>
                                    <span>Contact phụ</span>
                                </v-tooltip>
                            </td>
                            <td :rowspan="appointment.rowspan">{{ checkIsTodayOrTomorrow(_.get(appointment, 'date')) }}</td>
                            <td>{{ _.get(appointment, 'childCustomer[0].fullName', '') }}</td>
                            <td>{{  _.get(appointment, 'childCustomer[0].birthdayDescription', '') }}</td>
                            <td class="customer-course-column">{{ _.get(appointment, 'childCustomer[0].productDescription', '') }}</td>
                            <td :rowspan="appointment.rowspan">{{ _.get(appointment, 'description') }}</td>
                            <td v-if="showAction" :rowspan="appointment.rowspan">
                                <div class="action">
                                    <template v-if="appointment.status === appointmentStatus.PLANNING && checkAuthorization('appointment_update')">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn @click="updateAppointmentStatus(appointment,'cancel')" icon small color="default" v-on="on"><v-icon>mdi-close</v-icon></v-btn>
                                            </template>
                                            <span>Hủy lịch hẹn</span>
                                        </v-tooltip>
                                    </template>
                                    <template v-if="appointment.status === appointmentStatus.PLANNING && checkAuthorization('appointment_update')">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn class="mr-2"  @click="editAppointment(appointment)" icon small color="primary" dark v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                                            </template>
                                            <span>Cập nhật thông tin lịch hẹn</span>
                                        </v-tooltip>
                                    </template>
    <!--                                <template v-if="checkAuthorization('appointment_delete')">-->
    <!--                                    <v-tooltip bottom>-->
    <!--                                        <template v-slot:activator="{ on }">-->
    <!--                                            <v-btn @click="onClickDelete(appointment)" icon small color="default" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>-->
    <!--                                        </template>-->
    <!--                                        <span>Xóa lịch hẹn</span>-->
    <!--                                    </v-tooltip>-->
    <!--                                </template>-->
                                    <template v-if="appointment.status === appointmentStatus.PLANNING">
                                        <v-menu offset-y v-if="appointment.customer.contact && appointment.customer.contact.contactType == 'main'">
                                            <template v-slot:activator="{ on: menu, attrs }">
                                                <v-tooltip bottom>
                                                <template v-slot:activator="{ on: tooltip }">
                                                    <v-btn
                                                        class="icon-call"
                                                        icon
                                                        small
                                                        color="#a847bf"
                                                        v-bind="attrs"
                                                        v-on="{...tooltip, ...menu}"
                                                    >
                                                        <v-icon>mdi-phone</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Gọi cho khách hàng</span>
                                                </v-tooltip>
                                            </template>
                                            <v-list>
                                                <v-list-item
                                                    @click="executeCall(appointment, _.get(appointment, 'mobile', ''))"
                                                    class="main-mobile"
                                                >
                                                    <v-list-item-title>{{_.get(appointment, 'mobile', '')}}</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item
                                                        v-for="(phone, index) in appointment.customer.contact.phoneRelated"
                                                        :key="index"
                                                        @click="executeCall(appointment, phone)"
                                                        class="sub-mobile"
                                                    >
                                                    <v-list-item-title>{{phone}}</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                        <v-tooltip bottom v-else>
                                            <template v-slot:activator="{ on }">
                                                <v-btn  class="icon-call" @click="executeCall(appointment, appointment.mobile)" icon small color="#a847bf" v-on="on"><v-icon>mdi-phone</v-icon></v-btn>
                                            </template>
                                            <span>Thực hiện cuộc gọi</span>
                                        </v-tooltip>
                                    </template>
                                </div>
                            </td>
                        </tr>
                        <tr v-for="indexChild in (appointment.rowspan - 1)">
                            <td>{{ _.get(appointment.childCustomer[indexChild], 'fullName', '') }}</td>
                            <td>{{ _.get(appointment.childCustomer[indexChild], 'birthdayDescription', '') }}</td>
                            <td>{{ _.get(appointment.childCustomer[indexChild], 'productDescription', '') }}</td>
                        </tr>
                    </tbody>
                </template>
                <tbody v-else>
                    <tr>
                        <td colspan="1000">
                            <common-no-result />
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
        <convert-relation />
    </div>
</template>
<script>
    import ConvertRelation from "./ConvertRelation";
    import { appointmentStatus } from '../../../helpers/constants'
    import handleSchedule from '@/mixins/handleSchedule';
    import RepositoryFactory from '../../../repositories/RepositoryFactory'
    import TokenService from '../../../helpers/token';
    import moment from 'moment'
    import { showFbMessengerIcon } from '@/helpers/utils'
    const AppointmentRepository = RepositoryFactory.get('appointment')

    export default {
        mixins: [handleSchedule],
        components: { ConvertRelation },
        props: {
            filterForm: {
                type: Object,
                default: () => {},
            },
            appointments: {
                type: Array,
                default: () => [],
            },
            // users: {
            //     type: Array,
            //     default: () => [],
            // },
            showModal: {
                type: Boolean,
                default: false,
            },
        },
        mounted () {
            const showModal = this.$route.query.showModal || ''
            const appointmentId = this.$route.query.appointmentId || ''
            if(showModal) {
                if(appointmentId) {
                    this.editAppointment({id: appointmentId})
                }
            }
        },
        data() {
            return {
                dataAppointment: {},
                showModalCall: false,
                mobile: null,
                appointmentId: 0,
                selectedAppointment: {},
                appointmentStatus,
            }
        },
        created() {
        },
        computed: {
            showAction() {
                return this.checkAuthorization('appointment_update') || this.checkAuthorization('appointment_delete');
            }
        },
        destroyed() {
        },
        methods: {
            closeModalCall() {
                this.showModalCall = false
                this.mobile = '';
                this.appointmentId = 0;
            },
            executeCall (appointment, phone) {
                let userPosition = TokenService.getPosition()
                let userId = TokenService.getId()
                let contact = appointment.customer.contact
                if (userPosition == 'telesales' && userId != contact.userId) {
                    this.$swal({
                        title: 'Lỗi !',
                        text: 'Contact không thuộc quyền phụ trách.'
                    })
                } else {
                    const data = {
                        mobile: phone,
                        id: appointment.id,
                        customer: {
                            contactId: _.get(appointment, 'customer.contactId', ''),
                        },
                        mainId: contact ? appointment.customer.contact.mainId : null,
                        mainMobile: contact ? appointment.customer.contact.phoneRelated[0] : null
                    }
                    Bus.$emit('appointment-show-form-from-action', data)
                }
            },
            editAppointment (appointment) {
                let userPosition = TokenService.getPosition()
                let userId = TokenService.getId()
                let contact = appointment.customer.contact
                if (userPosition == 'telesales' && userId != contact.userId) {
                    this.$swal({
                        title: 'Lỗi !',
                        text: 'Contact không thuộc quyền phụ trách.'
                    })
                } else {
                    const appointmentDetail = {
                        id: appointment.id,
                        mainId: contact ? contact.mainId : null,
                        mainMobile: contact ? contact.phoneRelated[0] : null
                    }
                    Bus.$emit('appointment-show-form-from-appointment', appointmentDetail)
                }
            },
            async updateAppointmentStatus (appointment, status) {
                let userPosition = TokenService.getPosition()
                let userId = TokenService.getId()
                let contact = appointment.customer.contact
                if (contact && userPosition == 'telesales' && userId != contact.userId) {
                    this.$swal({
                        title: 'Lỗi !',
                        text: 'Contact không thuộc quyền phụ trách.'
                    })
                    return
                } 
                if (contact && contact.mainId && status == 'done') {
                    this.$swal({
                        title: 'Số điện thoại đã được gộp vào contact ' + contact.phoneRelated[0] + '.<br>Vui lòng thực hiện các thao tác tại contact chính.',
                        confirmButtonText: 'Xem contact chính',
                        showCancelButton: true,
                        cancelButtonText: 'Quay lại'
                        }).then((res) => {
                        if (res.value) {
                            let routeData = this.$router.resolve({
                            name: 'ContactDetail',
                            params: {
                                id: contact.mainId || 0
                            }
                            })
                            window.open(routeData.href, '_blank')
                        }
                    })
                } else if (contact && contact.mainId) {
                    let now = moment().format("YYYY-MM-DD HH:mm:ss")
                    if (appointment.date > now) {
                        this.$swal({
                            title: "Contact " + appointment.mobile + " còn lịch hẹn chưa thực hiện.",
                            showCancelButton: true,
                            cancelButtonText: "Quay lại",
                            confirmButtonText: "Hủy"
                        }).then(res => {
                            if (res.value) {
                                const statusAppointment = {
                                    status,
                                }
                                Bus.$emit('cancel-sub-contact-appointment', appointment, statusAppointment)
                            }
                        })
                    } else {
                        const statusAppointment = {
                            status,
                        }
                        Bus.$emit('cancel-sub-contact-appointment', appointment, statusAppointment)
                    }
                } else if (contact && userPosition == 'telesales' && userId != contact.userId && userId == appointment.userId) {
                    const statusAppointment = {
                        status,
                    }
                    Bus.$emit('cancel-sub-contact-appointment', appointment, statusAppointment)
                } else {
                    const statusAppointment = {
                        status,
                    }
                    Bus.$emit('show-relation-from-convert-status', appointment, statusAppointment)
                }
            },

            checkContactSources(contactSources) {
                return showFbMessengerIcon(contactSources)
            }
        }
    }
</script>

<style scoped>
/deep/ table {
    border-collapse: collapse;
}

/deep/ table tr td {
    border-bottom: 1px solid #DDDDDD;
}

/deep/ tbody:hover td[rowspan], tr:hover td {
   background: #DDDDDD; 
}
/deep/  th.customer-course-column {
  width: 100px !important;

}
/deep/ td.customer-course-column {
  max-width: 100px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>